import { Component, Inject, OnInit, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors} from "@angular/forms";
import {Apollo} from "apollo-angular";
import {
get_company_event_types
} from "../../company-events/graphql/getCompanyEvents";
import {
  CompanyEventCalendarManagerService
} from "../../company-events/company-events-calendar/company-event-calendar-manager.service";
import {DateTimeService} from "../../services/date-time.service";


@Component({
    selector: 'add-company-event-modal',
    templateUrl: './add-company-event-modal.component.html',
    styleUrls: ['./add-company-event-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddCompanyEventModalComponent implements OnInit{

  companyEventForm: FormGroup = new FormGroup({
    name: new FormControl(null, Validators.required),
    type: new FormControl(null, Validators.required),
    startDate: new FormControl(null, Validators.required),
    endDate: new FormControl({ value: null, disabled: true}),
    startTime: new FormControl({value: null, disabled: true}),
    endTime: new FormControl({value: null, disabled: true},),
    is_sponsored: new FormControl(false),
    sponsorshipAmount: new FormControl(null,),
    is_cosponsored: new FormControl(false),
    cosponsor: new FormControl(null),
    timezone: new FormControl(null)
  })
  onSaveAndClose: EventEmitter<any> = new EventEmitter()
  onSave: EventEmitter<any> = new EventEmitter()
  selectEventTypes: any = []
  localTimezone:any;
  timezones: any[];
  @Input() isLoading: boolean = false;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private apollo: Apollo, private dateTime: DateTimeService, private datetimeService: DateTimeService,) {
  }

  ngOnInit() {
    this.localTimezone = this.dateTime.getLocalTimezone()
    this.companyEventForm.controls["timezone"].setValue(this.localTimezone.tz)
    this.timezones = this.datetimeService.timezones;
    this.apollo.watchQuery({
      query: get_company_event_types,
    }).valueChanges.subscribe(({data}) => {
      let response:any = data;
      this.selectEventTypes = response.company_event_types;
    })
  }

  validateFormFields(){
    return !!(this.companyEventForm.get('name')?.valid && this.companyEventForm.get('type')?.valid && this.companyEventForm.get('startDate')?.valid);
  }

  saveAndClose(){
    this.isLoading = true;

    let formData = {
      name: this.companyEventForm.controls['name'].value,
      type: this.companyEventForm.controls['type'].value,
      is_sponsored: this.companyEventForm.controls["is_sponsored"].value,
      is_cosponsored: this.companyEventForm.controls["is_cosponsored"].value,
      sponsorship_amount: this.companyEventForm.controls["sponsorshipAmount"].value,
      cosponsor: this.companyEventForm.controls["cosponsor"].value,
      startDate: this.companyEventForm.controls["startDate"].value,
      endDate: this.companyEventForm.controls["endDate"].value,
      startTime: this.companyEventForm.controls["startTime"].value,
      endTime: this.companyEventForm.controls["endTime"].value,
      timezone: this.companyEventForm.controls["timezone"].value
    }
    let closeData = {
      formData: formData,
      formGroup: this.companyEventForm
    }
    this.onSaveAndClose.emit(closeData)

  }

  saveAndAdd(){
    this.isLoading = true;
    let formData = {
      name: this.companyEventForm.controls['name'].value,
      type: this.companyEventForm.controls['type'].value,
      is_sponsored: this.companyEventForm.controls["is_sponsored"].value,
      is_cosponsored: this.companyEventForm.controls["is_cosponsored"].value,
      sponsorship_amount: this.companyEventForm.controls["sponsorshipAmount"].value,
      cosponsor: this.companyEventForm.controls["cosponsor"].value,
      startDate: this.companyEventForm.controls["startDate"].value,
      endDate: this.companyEventForm.controls["endDate"].value,
      startTime: this.companyEventForm.controls["startTime"].value,
      endTime: this.companyEventForm.controls["endTime"].value,
      timezone: this.companyEventForm.controls["timezone"].value
    }

    let closeData = {
      formData: formData,
      formGroup: this.companyEventForm
    }
    this.onSave.emit(closeData)
  }

  close(){
    this.dialogRef.close()
  }

  resetForm(formGroup: FormGroup){
    formGroup.setValue({
      name: null,
      type: null,
      is_sponsored: false,
      is_cosponsored: false,
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
      sponsorshipAmount: null,
      cosponsor: null,
      timezone: null
    })
  }

  onKeyUp(event:any){
    if(this.companyEventForm.controls['startDate'].value!==null){
      this.companyEventForm.controls['endDate'].enable()
      this.companyEventForm.controls['startTime'].enable()
      this.companyEventForm.controls['endTime'].enable()
    }
  }

}
